import { TableBody } from './components/TableBody'
import { TableCell, TableHeaderCell } from './components/TableCell'
import { TableHeader } from './components/TableHeader'
import { TableRoot } from './components/TableRoot'
import { TableRow } from './components/TableRow'
import {
  TableEmpty,
  TableLoading,
  TableLoadMore
} from './components/TableStates'
import { TableWrapper } from './components/TableWrapper'

export type { TableBodyProps } from './components/TableBody'
export { TableBody } from './components/TableBody'
export type {
  TableCellProps,
  TableHeaderCellProps
} from './components/TableCell'
export { TableCell, TableHeaderCell } from './components/TableCell'
export type { TableHeaderProps } from './components/TableHeader'
export { TableHeader } from './components/TableHeader'
export type { TableProps } from './components/TableRoot'
export { TableRoot as default } from './components/TableRoot'
export type { TableRowProps } from './components/TableRow'
export { TableRow } from './components/TableRow'
export type {
  TableEmptyProps,
  TableLoadingProps,
  TableLoadMoreProps
} from './components/TableStates'
export {
  TableEmpty,
  TableLoading,
  TableLoadMore
} from './components/TableStates'
export type { TableWrapperProps } from './components/TableWrapper'
export { TableWrapper } from './components/TableWrapper'

export const Table = Object.assign(TableRoot, {
  Wrapper: TableWrapper,
  Header: TableHeader,
  Body: TableBody,
  Row: TableRow,
  HeaderCell: TableHeaderCell,
  Cell: TableCell,
  LoadMore: TableLoadMore,
  Empty: TableEmpty,
  Loading: TableLoading
})
